import { object, string } from 'yup';

export const createIssue = object({
  subject: string().required().trim().min(3).label('عنوان'),
  description: string().required().trim().min(3).required().label('توضیحات')
});
